module.exports = __webpack_public_path__ + "PTSans-NarrowBold.8aeafec81f4f75acfe9e.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/PTSans-NarrowBold.woff2
// module id = ../../../../../src/assets/customfonts/PTSans-NarrowBold.woff2
// module chunks = styles